import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UtenteService } from 'src/app/services/users/utente.service';


interface PasswordField {
  type : string,
  hide : boolean
}
@Component({
  selector: 'app-change-pw-modal',
  templateUrl: './change-pw-modal.component.html',
  styleUrls: ['./change-pw-modal.component.css']
})

export class ChangePwModalComponent implements OnInit {
  
  @Input() userId : any | undefined;

  oldPw : string ='';
  newPw : string = '';
  confirmNewPw : string = '';

  field1 : PasswordField = {
    type:'password',
    hide: true
  }
  field2 : PasswordField = {
    type:'password',
    hide: true
  }
  field3 : PasswordField = {
    type:'password',
    hide: true
  }

  constructor(private toast : ToastService, private utenteservice : UtenteService, private translate : TranslateService,  public activeModal: NgbActiveModal,
    private confirmModalService: ModalServiceService) { }

  ngOnInit(): void {
  }

  async saveNewPw() {
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
    let check = await this.confirmModalService.openConfirm(label, message);
    if(check) {
      let body = {new_password: this.newPw, new_password_conf: this.confirmNewPw , old_password: this.oldPw};
      let response = await this.utenteservice.aggiornaPassword(this.userId, body);
      if(response.success) {
        this.activeModal.close(false);
        this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success");
        
      } else {
        this.toast.openToast(response.msg, "error");
      }
    }
    

  }

  close(){
    this.activeModal.close(false);
  }

  changePwVisibility(fieldNum : number) {
    switch (fieldNum) {
      case 1 : {
        this.field1.hide= !this.field1.hide;
        if(this.field1.hide) {
          this.field1.type= "password";
        } else {
          this.field1.type = "string";
        }
        break;
      };
      case 2 : {
        this.field2.hide= !this.field2.hide;
        if(this.field2.hide) {
          this.field2.type= "password";
        } else {
          this.field2.type = "string";
        }
        break;
      };
      case 3 : {
        this.field3.hide= !this.field3.hide;
        if(this.field3.hide) {
          this.field3.type= "password";
        } else {
          this.field3.type = "string";
        }
        break;
      }
    }
  }

}
